import { withShowIf } from "../../with-show-if/with-show-If.component";
import styled from "@emotion/styled";

interface EditInPlaceProps {
  editable: boolean;
}

export const EditInPlaceTextContainer = withShowIf(styled.span<EditInPlaceProps>`
  :hover {
    cursor: ${(props) => (props.editable ? "pointer" : "auto")};
  }
`);
